// extracted by mini-css-extract-plugin
export default {"root":"LandingPage_root__1XkXy","scrollTop":"LandingPage_scrollTop__dSNVn","scrollTopVisible":"LandingPage_scrollTopVisible__1A2dV"};